import Link from 'next/link'
import { ROUTES } from '../../constants'
import Vehicle from '../svg/vehicle'
import PersonShape from '../svg/person-shape'
import BackArrow from '../svg/back-arrow'
import { Desktop } from '../media'

export default function Menu({ onLogout }) {
  return (
    <div className='wrapper'>
      <ul className='optionsList'>
        <Desktop>
          <li>
            <Link legacyBehavior href={ROUTES.Account}>
              <a className='flex'>
                <div className='icon absoluteCenter'>
                  <PersonShape />
                </div>
                <span>My Account</span>
              </a>
            </Link>
          </li>
          <li className='flex'>
            <Link legacyBehavior href={ROUTES.Sell}>
              <a className='flex'>
                <div className='icon absoluteCenter'>
                  <Vehicle />
                </div>
                <span>Sell a vehicle</span>
              </a>
            </Link>
          </li>
        </Desktop>
        <li>
          <button className='flex flatBtn' onClick={onLogout}>
            <Desktop>
              <div className='icon absoluteCenter'>
                <BackArrow />
              </div>
            </Desktop>
            <span>Sign Out</span>
          </button>
        </li>
      </ul>

      <style jsx>{`
        .wrapper {
          padding: 1.7rem 2rem 0.3rem;
          width: 30rem;
          padding: 0.8rem;
          border-radius: 1rem;
          background: var(--secondary-bg-color);
          border: 1px solid rgba(255, 255, 255, 0.12);
          box-shadow: 0 1.2rem 3rem rgba(0, 0, 0, 0.45);

          .optionsList {
            color: var(--primary-text-color);
            font-size: 1.6rem;
            font-weight: 700;

            li {
              a,
              button {
                width: 100%;
                text-align: left;
                padding: 1.1rem 1.2rem;
                border-radius: 0.9rem;
                font-weight: 700;
                color: rgba(255, 255, 255, 0.9);

                &:hover {
                  background: rgba(255, 255, 255, 0.08);
                  color: #fff;
                }
              }

              :not(:last-child) {
                // margin: 0 0 2rem 0;
                border-bottom: 1px solid var(--secondary-input-bg);
              }
            }
          }
        }

        .icon {
          margin: 0 0.8rem 0 0;
          width: 2.2rem;
          height: 2.2rem;
          background: var(--secondary-button-bg);
          border-radius: 50%;

          :global(svg) {
            height: 1.2rem;
            width: 1.2rem;
            fill: #fff;
          }
        }

        @media (max-width: 1024px) {
          .wrapper {
            max-width: 100%;
            background: transparent;
            padding: 0;
            border: 0;
            width: 100%;
            box-shadow: none;

            .optionsList {
              display: block;

              li {
                margin: 0;
                padding: 0;
                border-bottom: 0;

                :not(:last-child) {
                  margin: 0;
                  border-bottom: 0.1rem solid var(--separator-line-color);
                }

                a,
                button {
                  display: flex;
                  gap: 0.8rem;
                  padding: 2rem 1.2rem;
                  font-size: 1.4rem;
                  font-weight: 700;
                  border-bottom: 1px solid #47648f;
                  border-radius: 0;
                }
              }
            }
          }
        }
      `}</style>
    </div>
  )
}
